// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import 'normalize.css/normalize.css' // 保护有价值的默认值，修复浏览器的bug，优化css可用性
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import * as filters from './filters'
import router from './router'
import echarts from 'echarts'
import virtualScroller from 'vue-virtual-scroller'
import Print from 'vue-print-nb'
import breadcrumb from '@/components/Breadcrumbs'
import pagination from '@/components/Pagination'
import pageBack from '@/components/PageBack'
import HelpPage from '@/components/HelpPage'
import PageTitle from '@/components/PageTitle'
import uploadImg from '@/components/uploadImg'
import changeArea from '@/components/changeArea'
import tooltip from '@/components/tooltip'
import initDirectives from '@/utils/directives'
import store from './store'
import AMap from 'AMap'
import VuePreview from 'vue2-preview'
import './utils/rem.js'
import './permission.js'
// 主题色
import '../theme/index.css'
// 富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
Vue.use(virtualScroller)
Vue.use(Print) // 注册
Vue.use(VuePreview)
require('./styles/global.scss')
// 注册全局时的过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Element)
window.AMap = AMap
// 解决$comfirm点击取消后空格键和回车键依然执行删除操作
Vue.prototype.onBlurFn = function (e) {
  if (e.target.nodeName === 'BUTTON') {
    e.target.blur()
  } else {
    e.target.parentNode.blur()
  }
}
// 单行超出
initDirectives(Vue)
Vue.directive('clickoutside', {
  bind: function (el, binding, vnode) {
    function documentHandler (e) {
      // console.log(e)
      // 需要忽略的class数组
      let ignoreClass = ['el-input__clear']
      let nowClass = (e.target.className).split(' ')
      let flag = false
      // 判断是否有需要忽略的class
      ignoreClass.forEach(item => {
        if (nowClass.includes(item)) {
          flag = true
        }
      })
      if (flag) { // 是需要忽略的class
        return false
      }
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) {
        binding.value(e)
      }
    }
    el._vueClickOutside_ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  unbind: function (el, binding) {
    // console.log(el)
    document.removeEventListener('click', el._vueClickOutside_)
    delete el._vueClickOutside_
  }
})

Vue.component('changeArea', changeArea) // 区域筛选组件
Vue.component('uploadImg', uploadImg) // 上传文件
Vue.component('breadCrumb', breadcrumb) // 面包屑组件
Vue.component('pagination', pagination) // 分页组件
Vue.component('page-back', pageBack) // 返回组件
Vue.component('HelpPage', HelpPage) // 帮助
Vue.component('PageTitle', PageTitle) // 标题
Vue.component('tooltip', tooltip) // 超出显示tooltip
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
